module.exports = __webpack_public_path__ + "static/media/check-mark.31282089.svg";